export class MessagingSummaryRequest {
  private Action = 'getmessagingsummary';

  constructor() {}
}
